module.exports = __webpack_public_path__ + "static/media/graphic@3x.79fb5935.png";